import React from 'react';
import BannerAdUnit from '../AdUnit/Banner';

export interface Props {}

const StudioProductsCatalogCardE: React.FC<Props> = () => (
  <BannerAdUnit
    width="306px"
    height="314px"
    realEstateId="34a38aec-f4df-4434-b76c-ceb291fc97c9"
  />
);
StudioProductsCatalogCardE.displayName = 'StudioProductsCatalogCardE';

export default StudioProductsCatalogCardE;
